<template>
    <div>&nbsp;</div>
</template>

<script>
    import BaseEditor from '@/components/query2/components/editors/base-editor';

    export default {
        name: 'boolean-editor',
        extends: BaseEditor,
        watch: {
            'item.operator': function update() {
                // since the component does not have a UI, we dispatch an update
                // based on the operator instead
                this.dispatchUpdate([this.item.isTrue]);
            },
        },
    };
</script>

<style scoped>

</style>
